import { createContext } from "react";

export enum DisplayMode {
	STANDALONE = "standalone",
	WIDGET = "widget",
}

const DisplayModeContext = createContext(null);

export default DisplayModeContext;
